import React, { useState } from "react";
import styles from "./TbkProduct.module.css";
import { handleCheckUserLogin } from "../../../MIS/Global";

const CustomTabs = ({ sizeData = [], description = [] }) => {
  const [activeTab, setActiveTab] = useState("home");

  const handleCheckIsLogin = () => {
    let isLogin = handleCheckUserLogin("userData", "id");
    return isLogin;
  };
  const handleSizePrice = (item) => {
    let isLogin = handleCheckIsLogin();
    if (isLogin <= 0) {
       if(Number(item?.ch_mrp || 0).toFixed(2) > Number(0).toFixed(2)){
        return item.ch_mrp;
       }else{
         return item.ps_price;
       }
    } else {
      // return item.ps_whlprice
      if(Number(item?.ch_mrp || 0).toFixed(2) > Number(0).toFixed(2)){
        return item.ch_mrp;
       }else{
         return item.ps_price;
       }
    }
  };
  return (
    <div className="tabs-container">
      {/* Tab Navigation */}
      <div className="tabs">
        <button
          className={activeTab === "home" ? "tab active" : "tab"}
          onClick={() => setActiveTab("home")}
        >
          Details
        </button>
        <button
          className={activeTab === "profile" ? "tab active" : "tab"}
          onClick={() => setActiveTab("profile")}
        >
          Size & Price
        </button>
        {/* <button
        className={activeTab === "contact" ? "tab active" : "tab"}
        onClick={() => setActiveTab("contact")}
        >
        Contact
        </button> */}
      </div>

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === "home" && (
          <ul className={styles.descriptionList}>
            {description.map((element, index) => (
              <li key={index} className={styles.descriptionItem}>
                {element?.description}
              </li>
            ))}
          </ul>
        )}
        {activeTab === "profile" && (
          <ul className={styles.sizePriceList}>                 
            {sizeData.map((item, index) => (
              <li key={item.id} className={styles.sizePriceItem}>
                <span className={styles.sizeName}>{item.sizename}</span>
                <span className={styles.price}>₹{handleSizePrice(item)}</span>
              </li>
            ))}
          </ul>
        )}
        {/* {activeTab === "contact" && <p>Tab content for Contact</p>} */}
      </div>

      {/* Inline CSS */}
      <style>
        {`
        .tabs-container {
        width: 100%;
        {/* max-width: 500px; */}
        margin: auto;
        font-family: Arial, sans-serif;
        }
        .tabs {
        display: flex;
        border-bottom: 2px solid #ddd;
        }
        .tab {
        flex: 1;
        padding: 10px 15px;
        cursor: pointer;
        background: none;
        border: none;
        border-bottom: 2px solid transparent;
        font-size: 16px;
        transition: all 0.3s ease;
        }
        .tab:hover {
        background: #f4f4f4;
        }
        .tab.active {
        border-bottom: 2px solid #007bff;
        color: #007bff;
        font-weight: bold;
        }
        .tab-content {
        padding: 20px;
        font-size: 16px;
        color: #333;
        }
        `}
      </style>
    </div>
  );
};

export default CustomTabs;
